var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "custom-navbar-manga-popup" }, [
    _setup.loading
      ? _c(
          "div",
          { staticClass: "loading-container" },
          [_c(_setup.VLoading)],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_setup.loading
      ? _c("div", { staticClass: "custom-navbar-manga-panel" }, [
          _c(
            "div",
            { staticClass: "custom-navbar-manga-left-panel" },
            _vm._l(_setup.recommendItems, function (card) {
              return _c(
                "a",
                {
                  key: card.season_id,
                  staticClass: "recommend-manga-card",
                  attrs: {
                    href:
                      "https://manga.bilibili.com/detail/mc" + card.season_id,
                  },
                },
                [
                  _c("div", { staticClass: "recommend-manga-card-image" }, [
                    _c("img", {
                      attrs: {
                        src: card.horizontal_cover + "@300w.jpg",
                        alt: card.title,
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "recommend-manga-card-title",
                      attrs: { title: card.title },
                    },
                    [_vm._v(_vm._s(card.title))]
                  ),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "custom-navbar-manga-panel-separator" }),
          _vm._v(" "),
          _c("div", { staticClass: "custom-navbar-manga-right-panel" }, [
            _c("div", { staticClass: "custom-navbar-manga-hot-title" }, [
              _vm._v("人气漫画"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "custom-navbar-manga-hot-list" },
              _vm._l(_setup.hotItems.slice(0, 7), function (card) {
                return _c(
                  "a",
                  {
                    key: card.comic_id,
                    staticClass: "hot-manga-card",
                    attrs: {
                      title: card.title,
                      href:
                        "https://manga.bilibili.com/detail/mc" + card.comic_id,
                    },
                    on: {
                      mouseenter: function ($event) {
                        _setup.previewCard = card
                      },
                      mouseleave: function ($event) {
                        _setup.previewCard = undefined
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "hot-manga-card-title" }, [
                      _vm._v(
                        "\n            " + _vm._s(card.title) + "\n          "
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _setup.previewCard
              ? _c("div", { staticClass: "hot-manga-card-preview" }, [
                  _c("img", {
                    attrs: {
                      src: _setup.previewCard.vertical_cover + "@450h.jpg",
                      alt: _setup.previewCard.title,
                    },
                  }),
                ])
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }